/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DemoLoginRequest
 */
export interface DemoLoginRequest {
    /**
     * 
     * @type {number}
     * @memberof DemoLoginRequest
     */
    business_ref: number;
    /**
     * 
     * @type {string}
     * @memberof DemoLoginRequest
     */
    email: string;
}

/**
 * Check if a given object implements the DemoLoginRequest interface.
 */
export function instanceOfDemoLoginRequest(value: object): value is DemoLoginRequest {
    if (!('business_ref' in value) || value['business_ref'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function DemoLoginRequestFromJSON(json: any): DemoLoginRequest {
    return DemoLoginRequestFromJSONTyped(json, false);
}

export function DemoLoginRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DemoLoginRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'business_ref': json['business_ref'],
        'email': json['email'],
    };
}

export function DemoLoginRequestToJSON(json: any): DemoLoginRequest {
    return DemoLoginRequestToJSONTyped(json, false);
}

export function DemoLoginRequestToJSONTyped(value?: DemoLoginRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'business_ref': value['business_ref'],
        'email': value['email'],
    };
}

